import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Radio from '../Radio/Radio';
import { IconArrow } from '../Icons';
import { StyledButton, StyledUl } from './SwatchDropdownStyles';

var _ref = React.createElement(IconArrow, null);

var SwatchDropdown = function SwatchDropdown(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownActive = _useState2[0],
      setDropdownActive = _useState2[1];

  useEffect(function () {
    setDropdownActive(false);
  }, [props.selectedVariant]);

  var toggleDropdown = function toggleDropdown() {
    setDropdownActive(!dropdownActive);
  };

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      StyledButton,
      {
        className: 'SwatchDropdownBtn',
        onClick: toggleDropdown,
        active: dropdownActive,
        'aria-label': 'Toggle Swatch Dropdown'
      },
      _ref
    ),
    React.createElement(
      StyledUl,
      { active: dropdownActive },
      props.option.values.filter(function (item, ind) {
        return ind > 3;
      }).map(function (value) {
        return React.createElement(Radio, {
          key: value,
          handleOptionChange: props.handleOptionChange,
          toggleDropdown: toggleDropdown,
          name: props.option.name,
          value: value,
          checked: props.selectedOptions[props.option.name] === value,
          variants: props.variants,
          selectedOptions: props.selectedOptions,
          productId: props.productId,
          useDropdown: props.useDropdown,
          dropdownActive: props.dropdownActive,
          radioType: 'SWATCH_DROPDOWN',
          parent: 'SwatchDropdown'
        });
      })
    )
  );
};

SwatchDropdown.propTypes = {
  handleOptionChange: PropTypes.func.isRequired,
  option: PropTypes.object,
  productId: PropTypes.string.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  selectedVariant: PropTypes.object,
  selectedVariantQuantity: PropTypes.number,
  useDropdown: PropTypes.bool,
  variants: PropTypes.array.isRequired,
  dropdownActive: PropTypes.bool
};

export default React.memo(SwatchDropdown);